var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [_vm._v("Social Accounts")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.AddAccounts.apply(null, arguments)
                }
              }
            },
            [_vm._v("Add Account")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "app-filter-good-table-container" },
            [
              _c("vue-good-table", {
                ref: "listsocialaccount",
                attrs: {
                  mode: "remote",
                  title: "List of Social Accounts",
                  totalRows: _vm.totalRecords,
                  columns: _vm.columns,
                  rows: _vm.rows,
                  "pagination-options": {
                    enabled: true,
                    mode: "pages",
                    pageLabel: "Page",
                    position: "bottom",
                    perPage: _vm.serverParams.perPage,
                    perPageDropdown: [25, 50, 100, 200, 500],
                    dropdownAllowAll: false
                  },
                  selectOptions: {
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: "custom-class",
                    selectionText: "rows selected",
                    clearSelectionText: "clear"
                  },
                  "search-options": {
                    enabled: false
                  }
                },
                on: {
                  "on-page-change": _vm.onPageChange,
                  "on-column-filter": _vm.onColumnFilter,
                  "on-per-page-change": _vm.onPerPageChange,
                  "on-sort-change": _vm.onSortChange
                },
                scopedSlots: _vm._u(
                  [
                    _vm._l(_vm.rows, function(row, key) {
                      return {
                        key: "table-row",
                        fn: function(props) {
                          return [
                            _c("div", { key: key }, [
                              props.column.field == "action"
                                ? _c("div", { staticClass: "table-action" }, [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-eye btn edit-btn-vvg waves-effect",
                                      attrs: {
                                        title: "View Social Media Account",
                                        "aria-hidden": "true"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.viewAccount(props.row.id)
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn edit-btn-vvg waves-effect",
                                        attrs: {
                                          title: "Delete Social Media Account",
                                          id: "delete"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.deleteSingleUser(
                                              props.row.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-trash",
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              props.column.field == "social_media_type"
                                ? _c("div", [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(
                                          _vm.capitalizeFirstLetter(
                                            props.row.social_media_type
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                : props.column.field == "updated_by"
                                ? _c("div", [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(
                                          _vm.capitalizeFirstLetter(
                                            props.row.updated_by
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                : props.column.field == "created_by"
                                ? _c("div", [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(
                                          _vm.capitalizeFirstLetter(
                                            props.row.created_by
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          props.formattedRow[props.column.field]
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ])
                          ]
                        }
                      }
                    })
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-944d6b54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-944d6b54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/socialmedia/socialAccounts.vue
// module id = null
// module chunks = 